<template>
  <div class="logo">
    <router-link :to="{path:'/'}">
      <!-- <LogoSvg />
      <h1 v-if="showTitle">{{ title }}</h1> -->
      <span v-if="!collapsed" class="logo-icon"></span>
      <span v-else class="logo-small-icon"></span>
    </router-link>
  </div>
</template>

<script>
import LogoSvg from '@/assets/img/logo.svg?inline'

export default {
  name: 'Logo',
  components: {
    LogoSvg
  },
  props: {
    title: {
      type: String,
      default: 'M Art',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: @primary-color;
}
</style>
